import React from 'react';
import { TeamBios } from '../TeamBios';
import { TeamSection } from '../TeamSection';
import { SectionLink } from '../SectionLink';

/**
 * Team page — bios of current team first, then open roles.
 * Story / origin lives on its own page.
 */
export function TeamPage() {
  return (
    <>
      <TeamBios />
      <TeamSection />
      <section className="section fade-in" style={{ paddingTop: '1rem', paddingBottom: '4rem' }}>
        <SectionLink to="/club">Order TrueNooch direct</SectionLink>
      </section>
    </>
  );
}
